import { useMutation } from '@tanstack/react-query';
import { authResetPasswordCreate } from '@wellstone-solutions/api/v2';
import { useSearchParams } from 'react-router-dom';

import type {
  PasswordResetConfirm,
  PasswordResetConfirmInputRequest,
} from '@wellstone-solutions/api/v2';
import type { AxiosError, AxiosResponse } from 'axios';

type PasswordResetFormValuesType = {
  password: string;
  passwordConfirmation: string;
};

export const useResetPassword = () => {
  const [searchParams] = useSearchParams();
  const user = searchParams.get('user_id')!;
  const token = searchParams.get('token')!;

  return useMutation<
    AxiosResponse<PasswordResetConfirm>,
    AxiosError<{ [key: string]: string[] }>,
    PasswordResetFormValuesType
  >({
    mutationFn: ({ password }) => {
      if (!user || !token) {
        console.error('Missing reset-password params: user and/or token.');
        return Promise.reject(
          new Error('Missing reset-password params: user and/or token.')
        );
      }
      const payload: PasswordResetConfirmInputRequest = {
        user,
        token,
        password,
      };
      return authResetPasswordCreate(payload);
    },
  });
};

export type { PasswordResetFormValuesType };
